import { bindContainer, buildBinderRegistry } from '@monofe/di';
export const globalBinder = buildBinderRegistry();
const globalContainer = globalBinder.container();
bindContainer(globalContainer);
export default Object.freeze(globalContainer);